import { z } from "zod"
import { ServiceAction } from "../service/service-part-action"
import { Product } from "./index"

export enum CatalogProductSource {
  SPECTER = "SPECTER",
  CRONA = "CRONA",
  MANUAL = "MANUAL",
}

const optionalCode = z
  .string()
  .trim()
  .nullable()
  .transform((value) => (value === "" ? null : value))

export const CatalogProductPartActionInputSchema = z.object({
  partId: z.guid(),
  action: z.nativeEnum(ServiceAction),
  isDefault: z.boolean(),
})
export type CatalogProductPartActionInput = z.infer<
  typeof CatalogProductPartActionInputSchema
>

export const UpsertCatalogProductSchema = z
  .object({
    name: z.string().trim().min(1),
    price: z.number().min(0),
    acquisitionCost: z.number().min(0).nullable(),
    ean: optionalCode,
    articleNumber: optionalCode,
    partActions: z.array(CatalogProductPartActionInputSchema),
  })
  .refine(
    (dto) =>
      new Set(dto.partActions.map((pa) => `${pa.partId}:${pa.action}`)).size ===
      dto.partActions.length,
    { message: "Duplicate part actions", path: ["partActions"] },
  )
export type UpsertCatalogProduct = z.infer<typeof UpsertCatalogProductSchema>

export interface CatalogProductPartAction {
  id: string
  partId: string
  partName: string
  action: ServiceAction
  isDefault: boolean
}

export interface CatalogProductDto {
  id: string
  externalId: string | null
  ean: string | null
  articleNumber: string | null
  priceWithVat: number
  acquisitionCost: number | null
  name: string
  source: CatalogProductSource
  stock: number | null
  partActions: CatalogProductPartAction[]
  createdAt: string
  updatedAt: string
}

export interface CatalogProductList {
  products: CatalogProductDto[]
  totalPages: number
}

export interface CatalogProductDefault {
  partId: string
  action: ServiceAction
  product: Product
}
